export class HighestHeight {

	constructor(elements) {
		this.elements = elements;
		this.handleHighestHeight();
	}

	/**
	 * Handles the heighest height
	 */
	handleHighestHeight() {
		const highestHeight = this.getHighestHeight();
		this.setHeightToElements(highestHeight);
	}

	/**
	 * Gets the highest height of all elements
	 * @returns {number}
	 */
	getHighestHeight() {
		let highest = 0;
		for (let i = 0; i < this.elements.length; i++) {
			const element = this.elements[i];
			const elementHeight = element.clientHeight;
			highest = elementHeight > highest ? elementHeight : highest;
		}
		return highest;
	}

	/**
	 * Sets all the elements to the highest height
	 * @param height
	 */
	setHeightToElements(height) {
		for (let i = 0; i < this.elements.length; i++) {
			this.elements[i].style.minHeight = height + 'px';
		}
	}
}
